import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { B2Button } from "@hdb/biome-2";
import "./view-more-button.scss";

const ViewMoreButtonComponent = ({ onClickHandler }: any) => {
  // const url = require("../../../../assets/images/plus.png");

  return (
    <B2Button
      variant="outline-primary"
      className="fw-medium view-more-btn"
      onClick={() => onClickHandler()}
    >
      View More <FontAwesomeIcon icon={faCirclePlus} className="fs-7 ms-2" />
    </B2Button>
  );
};

export default ViewMoreButtonComponent;
